module.exports = __webpack_public_path__ + "static/media/file.9d0069b2.svg";